import React from "react";
import { FormGroup, Label, Input } from "reactstrap";
import DataAlert from "../DataAlert";
import Feature from "../feature-flag/Feature";

/**
 * Displays the "Primary Voltage (kV)" select field.
 * Wrapped in a <Feature> that renders only when TransformerPrimaryVoltageEnabled is active.
 */
export default function PrimaryVoltageSelectField({
  primaryVoltagekV,
  primaryVoltageKeys,
  onChange,
  isDefault,
  onResolveDefault,
  inputId = "primaryVoltagekV",
  label = "Primary Voltage (kV)",
}: {
  primaryVoltagekV: number | string;
  primaryVoltageKeys: number[];
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  isDefault: boolean;
  onResolveDefault: () => void;
  inputId?: string;
  label?: string;
}) {
  return (
    <Feature flag="TransformerPrimaryVoltageEnabled">
      <FormGroup>
        <Label htmlFor={inputId}>
          {label}
          {isDefault && <DataAlert updateDefault={onResolveDefault} />}
        </Label>
        <Input
          type="select"
          name="primaryVoltagekV"
          id={inputId}
          value={primaryVoltagekV}
          onChange={onChange}
        >
          {primaryVoltageKeys.map((kv) => (
            <option key={kv} value={kv}>
              {kv}
            </option>
          ))}
        </Input>
      </FormGroup>
    </Feature>
  );
}
